/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-nested-ternary */
import { useState, useEffect, useCallback, FormEvent } from "react";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import apiRelatorio from "../../services/apiRelatorio";
import { useAuth } from "../../hooks/auth";
import { BO } from "../../interface/Bo";

import { MenuBoepm } from "../../components/menu-boepm/MenuBoepm";
import "./tabela.css";

interface Unidade {
  ID_UNID_OPERACIONAL: number;
  CD_OPERACIONAL: string;
}

export const BoPorOmeOcorrencia: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const [bos, setBos] = useState<BO[]>([]);
  const [total, setTotal] = useState(null);
  const [, setLoadingBo] = useState(false);

  const [loading, setLoading] = useState(false);
  const [ocorrencia, setOcorrencia] = useState("");
  const [unidades, setUnidades] = useState<Unidade[]>([]);

  const { logout } = useAuth();

  const storedToken = sessionStorage.getItem("@webSDS:token");

  const handleSelectChange = (event: MUI.SelectChangeEvent) => {
    event.preventDefault();
    setSelectedOption(event.target.value);
  };

  useEffect(() => {
    apiRelatorio
      .get("unidOperacional", {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setUnidades(response.data);
      });
  }, [setUnidades, storedToken]);

  useEffect(() => {
    setLoadingBo(true);
    const totalBos = async () => {
      try {
        const response = await apiRelatorio.get(`relatorios`, {
          headers: {
            id_ome: selectedOption,
            flag: 1,
            Authorization: `Bearer ${storedToken}`,
          },
          params: {
            page: 0,
            quantity: 1,
          },
        });

        if (response.status === 200) {
          setTotal(response.data.total);
          setBos({ ...bos });
        }
        if (response.status === 401) {
          toast.error(
            "A Sua sessão expirou, efetue login novamente para continuar usando o Polícia Ágil",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
          logout();
        }
      } catch (error) {
        setLoading(false);
        toast.error("Erro de conexão! Verifique sua internet", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      }
    };
    totalBos();
    setLoadingBo(false);
  }, [logout, selectedOption, storedToken]);

  const handleBoPorOcorrencia = useCallback(
    async (e?: FormEvent) => {
      e?.preventDefault();
      try {
        setLoading(true);
        const response = await apiRelatorio.get(
          `boCdOcorrencia?cd_ocorrencia=${ocorrencia}`,
          {
            headers: {
              id_ome: selectedOption,
              flag: 1,
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        if (response.status === 200) {
          setBos(response.data);
        }

        if (response.status === 400) {
          toast.error(`${response.data.message}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }
        if (response.status === 401) {
          toast.error(
            "A Sua sessão expirou, efetue login novamente para continuar usando o Polícia Ágil",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
          logout();
        }
        if (response.status === 404) {
          toast.error(`${response.data.message}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
          setBos([]);
        }

        if (response.status === 500 || response.status === 503) {
          toast.error(`${response.data.message}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }
        if (response.status === 504) {
          toast.error(
            "O Servidor demorou muito pra responder, tente novamente em instantes.",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
        }
        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        toast.error("Erro de conexão! Verifique sua internet", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      }
    },
    [logout, ocorrencia, selectedOption, storedToken]
  );

  const clearBo = () => {
    setBos([]);
    setOcorrencia("");
  };

  return (
    <MUI.Stack flexDirection="row" width="100%" height={["95vh", "80vh"]}>
      <MenuBoepm />

      <MUI.Stack gap={2} p={2} flex={1}>
        <MUI.Stack
          gap={[0, 1]}
          flexDirection={["column", "row"]}
          alignItems={["inherit", "center"]}
        >
          <MUI.FormControl sx={{ width: 300 }} size="small">
            <MUI.InputLabel>Unidades</MUI.InputLabel>
            <MUI.Select
              label="Unidades"
              value={selectedOption}
              onChange={handleSelectChange}
            >
              {unidades.map((unidade) => (
                <MUI.MenuItem
                  key={unidade.ID_UNID_OPERACIONAL}
                  value={unidade.ID_UNID_OPERACIONAL}
                >
                  {unidade.CD_OPERACIONAL}
                </MUI.MenuItem>
              ))}
            </MUI.Select>
          </MUI.FormControl>
          {total && (
            <MUI.Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: "blue",
              }}
            >
              {total} boletins de ocorrência
            </MUI.Typography>
          )}
        </MUI.Stack>

        <MUI.Grid
          alignItems="center"
          width={["100%", "100%", "100%", "80%", "60%"]}
          container
          spacing={1}
        >
          <MUI.Grid item xs={12} md={4} sm={4}>
            <MUI.TextField
              label="Nº da ocorrência"
              value={ocorrencia}
              onChange={(e) => setOcorrencia(e.target.value.replace(/\D/g, ""))}
              onKeyPress={(e) => {
                e.key === "Enter" && handleBoPorOcorrencia(e);
              }}
              fullWidth
              size="small"
              disabled={loading}
            />
          </MUI.Grid>

          <MUI.Grid item xs={12} md={3} sm={3}>
            <MUI.Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleBoPorOcorrencia}
              disabled={loading}
              startIcon={<Icon.Search />}
            >
              <MUI.Typography
                variant="button"
                whiteSpace="nowrap"
                textOverflow="ellipsis"
                overflow="hidden"
              >
                Pesquisar
              </MUI.Typography>
            </MUI.Button>
          </MUI.Grid>

          <MUI.Grid item xs={12} md={3} sm={3}>
            <MUI.Button
              fullWidth
              variant="outlined"
              color="secondary"
              onClick={clearBo}
              disabled={loading}
              startIcon={<Icon.Clear />}
            >
              <MUI.Typography
                variant="button"
                whiteSpace="nowrap"
                textOverflow="ellipsis"
                overflow="hidden"
              >
                Limpar resultado
              </MUI.Typography>
            </MUI.Button>
          </MUI.Grid>
        </MUI.Grid>

        {!loading ? (
          bos.length > 0 ? (
            <MUI.Stack
              width="97.5%"
              my={1}
              overflow="auto"
              sx={{
                boxShadow: "0 0 0.3rem #000000",
              }}
            >
              <Table className="table">
                <Thead>
                  <Tr>
                    <Th>Nº BO</Th>
                    <Th>Data</Th>
                    <Th>Natureza</Th>
                    <Th>Viatura</Th>
                    <Th>Condutor</Th>
                    <Th>Resultado da Ocorrência</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {bos.map((bo) => (
                    <Tr key={bo.ID_BO}>
                      <Td>
                        <a
                          className="linkBo"
                          href={`${
                            process.env.REACT_APP_URL_CERTIDAO
                          }/certidao/${
                            bo.ID_STATUS === 4 && bo.BO_DP ? bo.BO_DP : "1"
                          }/${bo.CD_OCORRENCIA}/${bo.CRC}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {bo.CD_OCORRENCIA}
                        </a>
                      </Td>

                      <Td>{bo.DATA_HORA}</Td>

                      <Td>{bo.NATUREZAS}</Td>

                      <Td>{bo.DS_VIATURA}</Td>

                      <Td>{bo.CONDUTOR}</Td>

                      <Td>{bo.NM_TIPO_DESFECHO}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </MUI.Stack>
          ) : (
            false
          )
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </MUI.Stack>
  );
};
